import { Query } from 'best-modules/utils'
import { sendRequest } from 'best-modules/vue-utils'
import {
  Permission,
  PermissionSection,
  Role,
  RoleCredentials,
} from '@/utils/types/role'
import { PaginationList } from 'best-modules/components/server-table/types'

interface PermissionListResponse {
  sections?: PermissionSection[]
  groups: Record<string, Permission[]>
  groupLabels: Record<string, string>
}

const roleList = (query: Query): Promise<PaginationList<Role>> => {
  return sendRequest({
    name: 'roleList',
    method: 'get',
    url: {
      url: '/json/role',
      query,
    },
  })
}

const roleSingle = (id: number): Promise<Role> => {
  return sendRequest({
    name: 'roleSingle',
    method: 'get',
    url: `/json/role/${id}`,
  })
}

const roleCreate = (payload: RoleCredentials): Promise<Role> => {
  return sendRequest({
    name: 'roleCreate',
    method: 'post',
    url: '/json/role/create',
    payload,
  })
}

const roleUpdate = (id: number, payload: RoleCredentials): Promise<Role> => {
  return sendRequest({
    name: 'roleUpdate',
    method: 'post',
    url: `/json/role/update/${id}`,
    payload,
  })
}

const roleDelete = (id: number): Promise<Role> => {
  return sendRequest({
    name: 'roleDelete',
    method: 'delete',
    url: `/json/role/delete/${id}`,
  })
}

const permissionList = (): Promise<PermissionListResponse> => {
  return sendRequest({
    name: 'permissionList',
    method: 'get',
    url: '/json/role/permissions',
  })
}

export {
  roleList,
  roleSingle,
  roleCreate,
  roleUpdate,
  roleDelete,
  permissionList,
  PermissionListResponse,
}
